import React from 'react';
import {
	BottomModal,
	MapsInputAutocomplete,
	MapsInputAutocompletePlaces,
	Touchable,
} from '.';
import { mapFx, types } from 'utils';
import { useAlert } from 'utils/alert';
import { _store, _update } from '_Store';

interface Props {
	changeLocation: boolean;
	setChangeLocation: (bool: boolean) => void;
}
const ChangeLocation = ({ changeLocation, setChangeLocation }: Props) => {
	const {
		__data: { location },
		__auth: { user },
	} = _store.useState();

	const [presentAlert] = useAlert();
	const [places, setPlaces] = React.useState<types.Address[]>([]);

	const getMyCurrentLocation = () => {
		mapFx.myCurrentLocation().then((address) => {
			if (address && address.x > 1) {
				_update.data('location', { ...location, address: { ...address } });
			} else {
				presentAlert(
					"We couldn't get your current location. Please allow location access or search for your address."
				);
			}
		});
	};

	const myAddresses = (
		user.address
			? Array.isArray(user.address)
				? user.address
				: [user.address]
			: []
	).filter((a) => a.x);

	return (
		<React.Fragment>
			<BottomModal
				open={changeLocation}
				title="Delivery address"
				onClose={() => {
					setChangeLocation(false);
				}}
			>
				<div className="p-3" style={{ minHeight: '70vh' }}>
					<div>
						<MapsInputAutocomplete onChange={setPlaces} />
						<Touchable onClick={getMyCurrentLocation}>
							<div className="py-1 small text-muted">
								Use my current location
							</div>
						</Touchable>
						<div>&nbsp;</div>
						<MapsInputAutocompletePlaces
							addresses={[...places, ...myAddresses]}
						/>
					</div>
				</div>
			</BottomModal>
		</React.Fragment>
	);
};

export default ChangeLocation;
